export const MessageCenterTypes = {
  SET_OPEN: 'MESSAGE_CENTER.SET_OPEN',
};
